export class StorePartRequest {
  storeId: number;
  search: string;
  limit: number;
  offset: number;
  sortProp: string;
  sortDir: string;
}
